import { render } from "./AttrViewer.vue?vue&type=template&id=c920b534&scoped=true"
import script from "./AttrViewer.vue?vue&type=script&lang=ts"
export * from "./AttrViewer.vue?vue&type=script&lang=ts"

import "./AttrViewer.vue?vue&type=style&index=0&id=c920b534&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-c920b534"

export default script